import { useDestinationFilteredProductAds, useProductAdsListViewed } from '@/scopes/product-ads/domain/hooks'
import { useMultiSelectFilter } from '@/scopes/search/search/domain/hooks'
import { radius, space, tok, tokPx } from '@sunwebgroup/ui-components'
import { useRef } from 'react'
import { styled } from 'styled-components'
import { ProductAdsComponent } from './ProductAds'
import { ProductAdsList } from './ProductAdsList'

const Wrapper = styled.div`
  position: relative;
  padding: ${space('primitives_space_16')} ${space('primitives_space_24')};
  display: flex;
  flex-direction: column;

  background: ${tok('semantics_views_background_color')};
  border-radius: ${radius('semantics_boxes_corner_radius')};
  border: ${tokPx('semantics_boxes_border_width')} solid ${tok('semantics_boxes_border_color')};
`

export function SearchTileProductAds({
  infoLabel,
  infoContent,
  contextItemId,
  headerTitle,
}: {
  infoLabel: string
  infoContent: string
  headerTitle: string
  contextItemId: string
}) {
  const { selectedValues: countrySelectedValues } = useMultiSelectFilter('Country')
  const { selectedValues: regionSelectedValues } = useMultiSelectFilter('Region')
  const { isLoading, data } = useDestinationFilteredProductAds({
    contextItemId,
    destinations: { Country: countrySelectedValues, Region: regionSelectedValues },
    componentType: 'SearchList',
  })
  const productAdsRef = useRef(null)
  useProductAdsListViewed(data, 'sponsored_plp', productAdsRef)

  const content = !data || data.length === 0
    ? null
    : (
        <Wrapper data-qa="product-ads">
          <ProductAdsComponent infoLabel={infoLabel} infoContent={infoContent} headerTitle={headerTitle}>
            <ProductAdsList data={data} isLoading={isLoading} type="sponsored_plp" />
          </ProductAdsComponent>
        </Wrapper>
      )

  return <div ref={productAdsRef}>{content}</div>
}
